import Wrapper from "./shared/Wrapper";
import Footer from "./shared/Footer";
import { useEffect } from "react";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// Import des composants
import AnimatedBackground from "../components/accueil/AnimatedBackground";
import HeroSection from "../components/accueil/HeroSection";
import ServicesSection from "../components/accueil/ServicesSection";
import StatsSection from "../components/accueil/StatsSection";
import PartnersCarousel from "../components/accueil/PartnersCarousel";
import FeaturesSection from "../components/accueil/FeaturesSection";
import CallToActionSection from "../components/accueil/CallToActionSection";

gsap.registerPlugin(ScrollTrigger);

export default function Accueil() {

  useEffect(() => {
    // Animation du titre hero optimisée
    gsap.fromTo(".hero-title",
      { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.15
      }
    );
  }, []);

  return (
    <div className="bg-black text-white overflow-hidden">

      {/* ================================================ */}
      {/* BACKGROUND GLOBAL AVEC LES ÉLÉMENTS TECH */}
      {/* ================================================ */}
      <AnimatedBackground variant="global" showNeuralNodes={true} showParticles={true} />

      <Wrapper>

        {/* ================================================ */}
        {/* SECTION HERO */}
        {/* ================================================ */}
        <HeroSection />

        {/* ================================================ */}
        {/* SECTION SERVICES */}
        {/* ================================================ */}
        <ServicesSection />

        {/* ================================================ */}
        {/* SECTION STATISTIQUES */}
        {/* ================================================ */}
        <StatsSection />

        {/* ================================================ */}
        {/* SECTION PARTENAIRES */}
        {/* ================================================ */}
        <PartnersCarousel />

        {/* ================================================ */}
        {/* SECTION POURQUOI NOUS CHOISIR */}
        {/* ================================================ */}
        <FeaturesSection />

        {/* ================================================ */}
        {/* SECTION CALL TO ACTION FINALE */}
        {/* ================================================ */}
        <CallToActionSection />

        {/* ================================================ */}
        {/* FOOTER AVEC MÊME FOND QUE LE HERO */}
        {/* ================================================ */}
        <div className="relative">
          <div className="absolute inset-0 bg-linear-to-br from-gray-900 via-black to-blue-900 z-0" />
          <div className="relative z-10">
            <Footer />
          </div>
        </div>

      </Wrapper>

    </div>
  );
}
